<template>
  <div id="services-bg">
    <div id="services-image-bg"></div>
    <div id="services-shadow"></div>
    <div id="services-color-bg"></div>
  </div>
</template>

<script>
export default { name: 'ServicesBG' };
</script>

<style scoped lang="scss">
  #services-bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  $bg-height: 50%;

  #services-image-bg {
    background-image: url("../../assets/backgrounds/bg-services.jpg");
    width: 100%; height: $bg-height;
    background-size: cover;
    background-position: center;
    box-shadow: inset 100vw 0 0 rgba(170,179,48, 0.9);
  }

  #services-shadow {
    position: absolute;
    height: 50px; width: 100%;
    top: calc(#{$bg-height} - 49px);
    background-image: linear-gradient(rgba(170,179,48, 0), rgba(170,179,48, 1));
  }

  #services-color-bg {
    background-color: #aab330;
    height: $bg-height;
  }
</style>
